import { CommonConfirmationDialog } from 'components/common/dialogs/confirmation';
import { useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';
import { usePitchUploaderStore } from 'stores/use-pitch-uploader-store';

/** Blocks in-app navigation (and back) while Pitch Uploader has unsaved preview data. */
export const PitchUploaderNavigationBlocker = () => {
  const dirty = usePitchUploaderStore((s) => s.dirty);
  const setDirty = usePitchUploaderStore((s) => s.setDirty);
  const blocker = useBlocker(dirty);

  const [dialogKey, setDialogKey] = useState<number>();

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setDialogKey(Date.now());
      return;
    }
    setDialogKey(undefined);
  }, [blocker.state]);

  if (!dialogKey) {
    return null;
  }

  if (blocker.state !== 'blocked') {
    return null;
  }

  return (
    <CommonConfirmationDialog
      key={dialogKey}
      identifier="PitchUploaderLeaveConfirmDialog"
      title="common.warning"
      description="common.unsaved-changes-msg"
      action={{
        label: 'common.proceed',
        onClick: () => {
          setDirty(false);
          blocker.proceed?.();
        },
      }}
      cancel={{
        onClick: () => {
          blocker.reset?.();
        },
      }}
    />
  );
};
